import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetWardActivities(id: string | undefined) {
  return useQuery(queries.locations.getWardActivitiesById(id || ''))
}
